import { AgxUserIntegrationConnections } from '@urbanx/agx.ui-components2';
import { useSearchParams } from 'react-router-dom';

const IntegrationsSettingsPage = () => {
  const [searchParams] = useSearchParams();

  return (
    <AgxUserIntegrationConnections
      returnPage="integrations"
      showLoadingState
      docuSignErrorCode={searchParams.get('docuSignErrorCode')}
      rpDataErrorCode={searchParams.get('rpDataErrorCode')}
    />
  );
};

export default IntegrationsSettingsPage;
